import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "empty-layout" }
const _hoisted_2 = { class: "login-page__content" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", { class: "login-page__title" }, "Авторизация в Wipon Pro", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "login-page__text" }, "Введите номер телефона для входа", -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Продолжить ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_input = _resolveComponent("base-input")!
  const _component_base_button = _resolveComponent("base-button")!
  const _component_base_loader = _resolveComponent("base-loader")!
  const _directive_mask = _resolveDirective("mask")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", {
      class: "login-page",
      onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleFormSubmit && _ctx.handleFormSubmit(...args)), ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _hoisted_4,
        _withDirectives(_createVNode(_component_base_input, {
          modelValue: _ctx.phone,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.phone) = $event)),
          label: "Телефон",
          prefix: "+7",
          light: "",
          autofocus: ""
        }, null, 8, ["modelValue"]), [
          [_directive_mask, '(###) ###-##-##']
        ]),
        _createVNode(_component_base_button, {
          filled: "",
          type: "primary",
          "html-type": "submit",
          class: "login-page__submit-button",
          block: true,
          disabled: !_ctx.isPhoneValid
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }, 8, ["disabled"])
      ]),
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_base_loader, {
            key: 0,
            type: "primary",
            size: "large"
          }))
        : _createCommentVNode("", true)
    ], 32)
  ]))
}